import { isEmpty } from 'lodash'
import { toast } from 'react-toastify'
import { delay, fork, take, takeEvery } from 'redux-saga/effects'
import { IToast } from '../../actions/toasts/fireToast'
import { Modals } from '../../containers/Modals/ModalContainer'
import { ReservationModalActions } from '../../reducers/bookingCalendar/actionNames'
import { ModalActions } from '../../reducers/modals/actionNames'
import { ToastAction } from '../../reducers/toasts/actionNames'

function success(action: IToast) {
  toast(action.message, {
    autoClose: action.toastId ? false : action.delayClose,
    className: 'success-background',
    containerId: action.container,
    toastId: action.toastId,
  })
}

function info(action: IToast) {
  toast(action.message, {
    autoClose: action.toastId ? false : action.delayClose,
    className: 'info-background',
    containerId: action.container,
    toastId: action.toastId,
  })
}

function warning(action: IToast) {
  toast(action.message, {
    autoClose: action.toastId ? false : action.delayClose,
    className: 'waring-background',
    containerId: action.container,
    toastId: action.toastId,
  })
}

function error(action: IToast) {
  toast(action.message, {
    autoClose: action.toastId ? false : action.delayClose,
    className: 'error-background',
    containerId: action.container,
    toastId: action.toastId,
  })
}

function* closeToast(toastId: IToast['toastId'], d: number | false = 5000) {
  if (d) {
    yield delay(d)
  } else {
    yield delay(5000)
  }
  toast.dismiss(toastId)
}

export default function*() {
  const forks = {}

  yield takeEvery(ToastAction.FireToastSuccess, success)
  yield takeEvery(ToastAction.FireToastInfo, info)
  yield takeEvery(ToastAction.FireToastWarning, warning)
  yield takeEvery(ToastAction.FireToastError, error)
  yield takeEvery(
    [
      ReservationModalActions.ToggleCreateReservationModalRedux,
      ReservationModalActions.ToggleUpdateReservationModalRedux,
      ModalActions.CloseModal,
    ],
    function(action) {
      Object.keys(forks)
        .filter(
          k =>
            !isEmpty(forks[k]) &&
            (forks[k].container === 'Event' ||
              (action.type === ModalActions.CloseModal &&
                (action as any).id !== Modals.ReservationDeleteModal)),
        )
        .forEach(k => {
          forks[k].f.cancel()
          forks[k] = null
          toast.dismiss(k)
        })
    },
  )

  while (true) {
    const action = yield take([
      ToastAction.FireToastSuccess,
      ToastAction.FireToastInfo,
      ToastAction.FireToastWarning,
      ToastAction.FireToastError,
    ])

    if (action.toastId !== undefined) {
      if (!isEmpty(forks[action.toastId])) {
        forks[action.toastId].f.cancel()
      }

      const f = yield fork(closeToast, action.toastId, action.delayClose)

      forks[action.toastId] = { container: action.container, f: f }
    }
  }
}
